module.exports = __webpack_public_path__ + "img/preview-inventory.104e2777.png";